<template>
  <div>
    <div class="pt-5"></div>
    <v-toolbar card color="white">
      <v-toolbar-title>Contacts</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-text-field
        solo
        hide-details
        prepend-inner-icon="search"
        placeholder="Tìm trên danh sách này"
        v-model="table.searchText"
      ></v-text-field>
      <v-tooltip bottom>
        <v-btn icon slot="activator" @click="exportToExcel()">
          <v-icon>save_alt</v-icon>
        </v-btn>
        <span>Tải về</span>
      </v-tooltip>
    </v-toolbar>
    <v-divider></v-divider>
    <v-data-table
      item-key="id"
      :headers="table.headers"
      :items="datasource"
      :rows-per-page-items="[5,10,20,50]"
      :loading="isLoading"
      :search="table.searchText"
    >
      <template slot="items" slot-scope="props">
        <td>{{ props.item.LastName }}</td>
        <td>{{ props.item.FirstName }}</td>
        <td>{{ props.item.Title }}</td>
        <td>{{ props.item.Department }}</td>
        <td>{{ props.item.Email }}</td>
        <td>{{ props.item.MobilePhone }}</td>
        <td>{{ props.item.OfficePhone }}</td>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import XLSX from 'xlsx';

export default {
  props: {
    name: String,
    datasource: Array,
    isLoading: Boolean
  },
  data () {
    return {
      table: {
        searchText: '',
        headers: [
          {
            text: 'LastName',
            value: 'LastName'
          },
          {
            text: 'FirstName',
            value: 'FirstName'
          },
          {
            text: 'Title',
            value: 'Title'
          },
          {
            text: 'Department',
            value: 'Department'
          },
          {
            text: 'Email',
            value: 'Email'
          },
          {
            text: 'MobilePhone',
            value: 'MobilePhone'
          },
          {
            text: 'OfficePhone',
            value: 'OfficePhone'
          }
        ]
      }
    };
  },
  methods: {
    exportToExcel () {
      if (this.datasource.length === 0) {
        window.getApp.showMessage('Không có dữ liệu', 'error');
        return;
      }

      let sheet = XLSX.utils.json_to_sheet(this.datasource);
      let wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, sheet, 'CrmContacts');
      XLSX.writeFile(wb, `${this.name} - CrmContacts.xlsx`);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/search/components/CrmContacts.vue